import React from 'react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';

export default function BrandOverview() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-4xl md:text-5xl font-display font-normal text-jackstone-blue mb-4">
          Brand Overview
        </h1>
        <p className="text-base text-body leading-relaxed">
          Jackstone's brand identity reflects over 85 years of engineering excellence
          in industrial freezing technology.
        </p>
      </div>

      <Card className="p-8 bg-light-blue border-jackstone-blue/20">
        <div className="mb-6">
          <h2 className="text-2xl font-heading font-semibold text-jackstone-blue mb-2">
            Frozen Today, Fresh Tomorrow
          </h2>
          <p className="text-body">
            Our brand tagline encapsulates our commitment to preserving quality and delivering excellence.
          </p>
        </div>
      </Card>

      <div className="grid md:grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="text-xl font-heading font-semibold text-body mb-3">
            Brand Identity
          </h3>
          <p className="text-body mb-4">
            Established in 1937, Jackstone represents trust, reliability, and innovation in industrial
            freezing solutions. We are engineers first, providing technical excellence to the global
            food industry.
          </p>
          <div className="flex flex-wrap gap-2">
            <Badge tone="grey" fill="soft">Heritage</Badge>
            <Badge tone="grey" fill="soft">Engineering</Badge>
            <Badge tone="grey" fill="soft">Innovation</Badge>
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="text-xl font-heading font-semibold text-body mb-3">
            Brand Personality
          </h3>
          <div className="space-y-3">
            <div>
              <div className="font-medium text-body mb-1">Expert & Knowledgeable</div>
              <p className="text-sm text-subtle">
                Deep industry understanding and technical mastery
              </p>
            </div>
            <div>
              <div className="font-medium text-body mb-1">Direct & Clear</div>
              <p className="text-sm text-subtle">
                Concise, action-oriented communication
              </p>
            </div>
            <div>
              <div className="font-medium text-body mb-1">Reliable & Assuring</div>
              <p className="text-sm text-subtle">
                Emphasising durability and long-term partnership
              </p>
            </div>
          </div>
        </Card>
      </div>

      <Card className="p-6">
        <h3 className="text-xl font-heading font-semibold text-body mb-3">
          Visual Direction
        </h3>
        <p className="text-body mb-4">
          Our visual identity combines industrial strength with modern professionalism.
          Clean lines, technical precision, and a confident color palette establish
          Jackstone as a leader in our field.
        </p>
        <div className="grid sm:grid-cols-3 gap-4 mt-6">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 rounded-lg bg-jackstone-blue flex items-center justify-center">
              <div className="text-3xl font-display font-normal text-white">P</div>
            </div>
            <div className="font-medium text-sm">Professional</div>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 rounded-lg bg-navy flex items-center justify-center">
              <div className="text-3xl font-display font-normal text-white">T</div>
            </div>
            <div className="font-medium text-sm">Technical</div>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 rounded-lg bg-light-blue flex items-center justify-center">
              <div className="text-3xl font-display font-normal text-body">M</div>
            </div>
            <div className="font-medium text-sm">Modern</div>
          </div>
        </div>
      </Card>

      <Card className="p-6 bg-surface">
        <h3 className="text-xl font-heading font-semibold text-body mb-3">
          Customer Perception
        </h3>
        <p className="text-body">
          Customers should perceive Jackstone as a trusted partner with unmatched expertise in
          freezing technology. Our brand communicates confidence, reliability, and a commitment
          to delivering solutions that preserve product quality and maximise operational efficiency.
          We are the choice of professionals who demand excellence.
        </p>
      </Card>
    </div>
  );
}
